import React, { useMemo, useState, useRef } from "react";
import Input from "../../../modules/Input";
import Card from "../../../modules/Card";
import api_requests from "../../../resources/api_requests";
import Spinner from "../../../modules/Spinner";
import { useTranslation } from "react-i18next";

const EnterPhone = ({ onNext, selectedCountry }) => {
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();

  const contactRef = useRef();

  const isIndonesia = selectedCountry === "indonesia";

  const form = useMemo(
    () => [
      {
        name: "contact",
        label: isIndonesia ? `${t("email_label")}*` : `${t("mobile_number")}*`,
        placeholder: isIndonesia ? t("email_placeholder") : t("enter_mobile_number"),
        ref: contactRef,
        type: isIndonesia ? "email" : "number",
      },
    ],
    [isIndonesia, t],
  );
  const allowDigitsOnly = (e) => {
      const value = e.target.value;

      if (/^\d{0,10}$/.test(value)) {
        e.target.value = value;
      } else {
        e.target.value = value.replace(/\D/g, "").slice(0, 10);
      }
  };

  const validators = {
    contact: (value) => {
      if (!value.trim()) {
        return isIndonesia ? t("email_req") : t("mobile_req");
      }
      if (isIndonesia) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          return t("valid_email");
        }
      } else {
        if (!/^\d+$/.test(value)) return t("only_digits");
        if (value.length !== 10) return t("enter_registered_num");
      }
      return "";
    },
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    form.forEach((field) => {
      const value = field.ref.current.value;
      const fieldError = validators[field.name](value);
      if (fieldError) {
        newErrors[field.name] = fieldError;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const contact = contactRef.current.value;

    const formData = {};
    form.forEach((field) => {
      formData[field.name] = field.ref.current.value;
    });

    setLoading(true);

    const apiParams = isIndonesia ? { email: contact } : { mobile: contact };

    api_requests.auth_status(apiParams).then((res) => {
      if (res.data.is_password_login_enabled) {
        api_requests
          .request_otp(apiParams)
          .then((res) => {
            // MARK::- HANDLE ERROR HERE
            console.log(res);
            onNext(formData);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setErrors({
          contact: isIndonesia ? ("enter_registered_email") : t("enter_registered_num"),
        });
        setLoading(false);
      }
    });
  };

  return (
    <div className="px-6 mt-10">
      <div className="flex flex-col items-center gap-0.5 justify-center">
        <p className="font-custom  text-2xl font-semibold text-[#7953D2] ">
          {t("forgot_password")}?
        </p>
        <p className="font-custom text-sm text-xs font-medium text-dark_gray ">
          {t("enter_contact_to_reset_password")}{" "}
        </p>
      </div>

      <Card>
        <div className="flex flex-col gap-[20px]">
          {form.map(({ name, label, placeholder, ref, type }) => {
            return (
              <div key={name}>
                <Input
                  label={label}
                  placeholder={placeholder}
                  ref={ref}
                  disabled={isLoading}
                  inputType={type}
                  onChange={allowDigitsOnly}
                />
                {errors[name] && (
                  <p className="text-red-500 text-xs mt-1">{errors[name]}</p>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-[34px]">
          <button
            onClick={handleSubmit}
            className="font-custom btn btn-block bg-[#492897] text-white rounded-[30px] text-base font-semibold disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <Spinner heightResponsive />
            ) : (
              <span>{t("continue")}</span>
            )}
          </button>
        </div>
      </Card>
    </div>
  );
};

export default EnterPhone;
